import axios from "axios";
import { getHeaders, checkStatus } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;

// get Survey List...

  export async function getSurveyList(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Form/Get`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

// add Survey Form  

  export async function addSurveyForm(params) {  
  try {
    const response = await axiosInstance.post(`${baseURL}/Form/Add`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }
  
}
 
// add Survey Questions&Options

  export async function addSurveyFormQuestion(params) {  
  try {
    const response = await axiosInstance.post(`${baseURL}/Form/Question/Add`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }

  //
  
}

// delete Delete Form..

   export async function deleteSurveyForm(params) { 
    try {
      const response = await axiosInstance.post(`${baseURL}/Form/Delete`, params,{
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

// delete All Response...

  // export async function deleteSurveyFormAllResponse(params) { 
  //   try {
  //     const response = await axiosInstance.delete(`${baseURL}/Form/DeleteAllResponse`, {
  //       headers: await getHeaders(),
  //       data: params,
  //     });
  //     checkStatus(response);
  //     return response.data;
  //   } catch (error) {
  //     return Promise.reject(error);
  //   }
  // }


    export async function deleteSurveyFormAllResponse(params) { 
    try {
      const response = await axiosInstance.post(`${baseURL}/Form/Response/DeleteAll`,params, {
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }



// delete Individual Response...

  export async function deleteSurveyIndividualResponse(params) { 
    try {
      const response = await axiosInstance.post(`${baseURL}/Form/Response/DeleteIndividual`, params, {
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }



// delete Questions


  export async function deleteSurveyQuestions(params) { 
    try {
      const response = await axiosInstance.post(`${baseURL}/Form/Question/Delete`,params, {
        headers: await getHeaders(),
        data: params,
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }



// get Survey Summary


  export const getSurveySummary = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Form/Summary`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }




// Published Survey form...


export async function publishUnpublishSurveyForm(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Form/Update/Visibility`,
      params,
      {
        headers: await getHeaders()
      }
    );

    checkStatus(response);
    return response.data;
  } catch (error) {
    throw error;
  }
}

//Submit Survey


export async function submitSurvey(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Form/Submit`,
      params,
      {
        headers: await getHeaders()
      }
    );

    checkStatus(response);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Published Survey form...


export async function stopSurveyForm(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Form/Update/Status`,
      params,
      {
        headers: await getHeaders()
      }
    );

    checkStatus(response);
    return response.data;
  } catch (error) {
    throw error;
  }
}


// Form UserList

  // export async function getFormUserList(params) {
  //   try {
  //     const response = await axiosInstance.post(`${baseURL}/Form/Responses`,params, {
  //       headers: await getHeaders(),
  //       body: JSON.stringify(params)
  //     });
  //     checkStatus(response);
  //     return response.data;
  //   }catch(error){
  //     return Promise.reject(error);
  //   }
    
  // }

  export async function getFormUserList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Form/Responses`,
      params,
      {
        headers: await getHeaders()
      }
    );

    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



